import { createSlice } from '@reduxjs/toolkit';

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    isAuthenticated: false,
    token: null,
    user: null,
    permissions: null,
    userInfo: null
  },
  reducers: {
    login: (state, action) => {
      const { token, user } = action.payload;
      state.isAuthenticated = true;
      state.token = token;
      state.user = user;
      state.userInfo = user
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.token = null;
      state.user = null;
    },
    profile: (state, action) => {
      state.user = { ...state.user, ...action.payload };
    },
    setUserData: (state, action) => {
      const user = action.payload;
      state.user = user;
      state.userInfo = user;

    },
    setUserPermissions: (state, action) => {
      state.permissions = action.payload
    },
    updateOnboardStep: (state, action) => {
      if (state.userInfo) {
        state.userInfo.on_board_step = action.payload.on_board_step;
        state.userInfo.is_on_board_complete = action.payload.is_on_board_complete
      }
    },
  },
});

export const { login, logout, forgotPassword, profile, setUserData, setUserPermissions, updateOnboardStep } = authSlice.actions;

export default authSlice.reducer;